import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function TrimLengthValidator(length: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;

    if (value) {
      return value.trim().length === length ? null : { length: true };
    }

    return null;
  };
}
